import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import {
  Button,
} from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AlertModal = ({
  isOpen,
  toggleIsOpen,
}) => (
  <Modal isOpen={isOpen} toggle={toggleIsOpen}>
    <ModalHeader toggle={toggleIsOpen}>
      <FontAwesomeIcon icon="ban" />&nbsp;Health Information is under review
    </ModalHeader>
    <ModalBody>
      <p>
        {'The child has one or more MRNs under review. You will be unable to view healthcare information associated with those MRNs until the review is complete. If no other healthcare data is available, you will only find data on the Primary Contacts and Children\'s Services pages.'}
      </p>
    </ModalBody>
    <ModalFooter>
      <Button
        className="ml-auto"
        outline
        onClick={() => toggleIsOpen()}
      >
        Continue
      </Button>
    </ModalFooter>
  </Modal>
);

AlertModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
};

export default AlertModal;
